import React from "react";
import "./Publications.css"

export const Publications = () => {
    return (
        <div className="container text-center my-5">
            <h2 className="fw-bold">OUR BOOKS PUBLICATIONS</h2>
            <hr className="custom-line bg-warning mb-4 text-center" />

            <div id="bookCarousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <a href="http://researchdiscourse.org/wp-content/uploads/2021/05/11.jpg"
                            target="_blank" rel="noopener noreferrer">
                            <img src="http://researchdiscourse.org/wp-content/uploads/2021/05/11.jpg"
                                className="d-block w-100 rounded shadow" alt="Book 1" />
                        </a>

                    </div>

                    <div className="carousel-item">
                        <a href="http://researchdiscourse.org/wp-content/uploads/2021/05/13.jpg"
                            target="_blank" rel="noopener noreferrer">
                            <img src="http://researchdiscourse.org/wp-content/uploads/2021/05/13.jpg"
                                className="d-block w-100 rounded shadow" alt="Book 2" />
                        </a>

                    </div>
                </div>

                {/* Carousel Controls */}
                <button className="carousel-control-prev" type="button" data-bs-target="#bookCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#bookCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                </button>
            </div>
        </div>
    );
};
